import { useCallback } from 'react'

// import { DISPLAY_DATE_FORMAT } from '../../../utils/dayjs'
// import { values } from '../../../utils/javascript'
// import {
//   availableNursingStaffKeys,
//   drinkingWaterKeys,
//   hotBathingWaterKeys,
//   vegetableQualityKeys,
// } from '../../dashboard/dashboard.description'
import {
  /* booleanOptions, */ inspectionReportOptions,
} from '../jobs.description'

const inspectionReportFields = ({
  fieldName,
  photoField,
  remarkField,
  label,
}) => {
  return {
    [fieldName]: {
      label,
      inputType: 'select',
      options: inspectionReportOptions,
      required: true,
      md: 24,
      xs: 24,
    },
    [photoField]: {
      label: 'job_Photo',
      inputType: 'formUpload',
      acceptFileTypes: '.png,.jpg,.jpeg',
      required: data => data?.[fieldName] === 'CRITICAL',
      hidden: data =>
        !['NEEDS_ATTENTION', 'CRITICAL'].includes(data?.[fieldName]),
      disableGalleryUpload: true,
      max: 5,
      md: 24,
      xs: 24,
    },
    [remarkField]: {
      label: 'job_Remarks',
      inputType: 'textArea',
      required: data => data?.[fieldName] === 'CRITICAL',
      rows: 2,
      hidden: data =>
        !['NEEDS_ATTENTION', 'CRITICAL'].includes(data?.[fieldName]),
      md: 24,
      xs: 24,
    },
  }
}

const inspectionFieldAttr = () => {
  // const hostelAdministrationAttrFn = useCallback(
  //   () => ({
  //     // hostelAuthority: {
  //     //   title: 'job_AdministrationGovernance',
  //     // },
  //     /*
  //     Legacy hostel administration fields are commented out temporarily as requested.
  //     hostelAuthority: {
  //       title: 'job_HostelAuthority',
  //     },
  //     principalHwoSpecialOfficerName: {
  //       label: 'job_NameOfPrincipalHWOSpecialOfficer',
  //       inputType: 'input',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     principalIsRegularOrIncharge: {
  //       label: 'job_WhetherThePrincipalHWOSpecialOfficerIsRegularOrIncharge',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     principalPresentDuringInspection: {
  //       label:
  //         'job_WhetherThePrincipalHWOSpecialOfficerWasPresentDuringInspection',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     principalStaysInHeadquarters: {
  //       label: 'job_WhetherThePrincipalHWOSpecialOfficerStaysInTheHeadquarters',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfStudentsEnrolled: {
  //       label: 'job_NumberOfStudentsEnrolled',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfBoys: {
  //       label: 'job_NumberOfBoys',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfGirls: {
  //       label: 'job_NumberOfGirls',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfStudentsMarkedAttendance: {
  //       label: 'job_NumberOfStudentsMarkedAttendance',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     studentsActuallyPresentDuringInspection: {
  //       label: 'job_NumberOfStudentsActuallyPresentAtTheTimeOfInspection',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     recordMaintenance: {
  //       title: 'job_RecordMaintenance',
  //     },
  //     staffAttendanceRecordMaintained: {
  //       label: 'job_IsTheRecordOfStaffAttendanceMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boarderAttendanceRecordMaintained: {
  //       label: 'job_IsTheRecordOfBoarderAttendanceMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     sickBoardersRecordMaintained: {
  //       label: 'job_IsTheRecordOfSickBoardersMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boarderMovementRecordMaintained: {
  //       label: 'job_IsTheRecordOfBoarderMovementMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     visitorRegisterMaintained: {
  //       label: 'job_IsVisitorRegisterMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     treasuryBillRegisterMaintained: {
  //       label: 'job_TreasuryBillRegisterMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     allOtherRecordsMaintainedRegularly: {
  //       label: 'job_AreAllOtherRecordsMaintainedRegularly',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     staffDetails: {
  //       title: 'job_StaffDetails',
  //     },
  //     numberOfWorkersOnPayroll: {
  //       label: 'job_NumberOfWorkersOnPayroll',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfCooksEnrolled: {
  //       label: 'job_NumberOfCooksEnrolled',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfCooksPresent: {
  //       label: 'job_NumberOfCooksPresent',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfKamatiEnrolled: {
  //       label: 'job_NumberOfKamatiEnrolled',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfKamatiPresent: {
  //       label: 'job_NumberOfKamatiPresent',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfWatchmenAttendersEnrolled: {
  //       label: 'job_NumberOfWatchmenEnrolled',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfWatchmenAttendersPresent: {
  //       label: 'job_NumberOfWatchmenPresent',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfScavengersAvailable: {
  //       label: 'job_NumberOfScavengersAvailable',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfScavengersRequired: {
  //       label: 'job_NumberOfScavengersRequired',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     */
  //     ...inspectionReportFields({
  //       fieldName: 'studentAttendanceHostelOccupancyRecordsUpdated',
  //       photoField: 'studentAttendanceHostelOccupancyRecordsUpdatedDmsIds',
  //       remarkField: 'studentAttendanceHostelOccupancyRecordsUpdatedRemarks',
  //     }),
  //     ...inspectionReportFields({
  //       fieldName: 'physicalStudentCountsMatchAttendanceRecords',
  //       photoField: 'physicalStudentCountsMatchAttendanceRecordsDmsIds',
  //       remarkField: 'physicalStudentCountsMatchAttendanceRecordsRemarks',
  //     }),
  //     ...inspectionReportFields({
  //       fieldName: 'mandatoryRegistersRecordsAvailableUpdated',
  //       photoField: 'mandatoryRegistersRecordsAvailableUpdatedDmsIds',
  //       remarkField: 'mandatoryRegistersRecordsAvailableUpdatedRemarks',
  //     }),
  //   }),
  //   [],
  // )
  // const hostelInfraRoomsAttrFn = useCallback(
  //   () => ({
  //     livingSpace: {
  //       title: 'job_LivingSpace',
  //     },
  //     hostelLocationType: {
  //       label: 'job_HostelLocationType',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: [
  //         { label: 'dash_Government', value: 'GOVERNMENT' },
  //         { label: 'dash_Private', value: 'PRIVATE' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfLivingRooms: {
  //       label: 'job_NumberOfLivingRooms',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     bedsAvailableForAllBoarders: {
  //       label: 'job_BedsAvailableForAllBoarders',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     typeOfBedsAvailable: {
  //       label: 'job_TypeOfBedsAvailable',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: [
  //         { label: 'job_SingleBeds', value: 'SINGLE_BED' },
  //         { label: 'job_BunkerBeds', value: 'BUNKER_BED' },
  //         { label: 'job_NoBedsAvailable', value: 'NO_BED_AVAILABLE' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     mattressesAvailableForBoarders: {
  //       label: 'job_MattressesAvailableForBoarders',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     mattressesRequired: {
  //       label: 'job_NumberOfMattressesRequired',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     accommodationSufficient: {
  //       label: 'job_AccommodationSufficient',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     windowIssues: {
  //       label: 'job_WindowIssues',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: [
  //         { label: 'job_BrokenNoDoors', value: 'BROKEN_NO_DOORS' },
  //         { label: 'job_BrokenNoGlass', value: 'BROKEN_NO_GLASS' },
  //         { label: 'job_BrokenNoGrill', value: 'BROKEN_NO_GRILL' },
  //         { label: 'job_BrokenNoMesh', value: 'BROKEN_NO_MESH' },
  //         { label: 'txt_None', value: 'NONE' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     electricity: {
  //       title: 'job_Electricity',
  //     },
  //     totalTubelightsBulbsWorking: {
  //       label: 'job_WorkingLightsCount',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     properLightingArrangementsMade: {
  //       label: 'job_ProperLightingArrangements',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     totalFansWorking: {
  //       label: 'job_WorkingFansCount',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     properVentilationArrangementsMade: {
  //       label: 'job_ProperVentilationArrangements',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     inverterAvailable: {
  //       label: 'job_InverterAvailable',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     electricalIssuesPresent: {
  //       label: 'job_ElectricalIssuesPresent',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: [
  //         { label: 'job_WiringIssues', value: 'WIRING_ISSUES' },
  //         { label: 'job_PhaseOverload', value: 'PHASE_OVERLOAD' },
  //         { label: 'job_LightingFanIssues', value: 'LIGHTING_AND_FAN_ISSUES' },
  //         { label: 'dash_Others', value: 'OTHERS' },
  //         { label: 'job_NoIssues', value: 'NO_ISSUES' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     electrificationRepairsRequired: {
  //       label: 'job_ElectricalRepairsDescription',
  //       inputType: 'textArea',
  //       maxLength: 1000,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const hostelInfraSanitationAttrFn = useCallback(
  //   () => ({
  //     solidWasteManagement: {
  //       title: 'job_SolidWasteManagement',
  //     },
  //     gpMunicipalityClearingSolidWasteRegularly: {
  //       label: 'job_IsWasteRegularlyCleared',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     wasteDisposedInOpenAreaDuringVisit: {
  //       label: 'job_IsWasteDisposedInOpenArea',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     liquidWasteManagement: {
  //       title: 'job_LiquidWasteManagement',
  //     },
  //     greyBlackWaterSeparatelyDrained: {
  //       label: 'job_IsWaterSeparatelyDrained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     septicTankCleanedRegularly: {
  //       label: 'job_IsSepticTankCleanedRegularly',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     stagnantWaterOnGround: {
  //       label: 'job_IsStagnantWaterPresent',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     soakPitsInHostel: {
  //       label: 'job_AreSoakPitsAvailable',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     sufficientDistanceSepticTankBorewell: {
  //       label: 'job_SufficientDistanceBetweenSepticTankAndBoreWell',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     hostelPremisesKeptClean: {
  //       label: 'job_ArePremisesClean',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     toilets: {
  //       title: 'job_Toilets',
  //     },
  //     numberOfToiletsAvailable: {
  //       label: 'job_NumberOfToiletsAvailable',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfToiletsFunctioning: {
  //       label: 'job_NumberOfToiletsFunctioning',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     percentageOfToiletFunctioning: {
  //       label: 'job_PercentageOfTotalToiletsFunctioning',
  //       inputType: 'input',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfToiletsSufficient: {
  //       label: 'job_AreToiletsSufficient',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfBathroomsAvailable: {
  //       label: 'job_NumberOfBathroomsAvailable',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfBathroomsFunctioning: {
  //       label: 'job_NumberOfBathroomsFunctioning',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfBathroomsSufficient: {
  //       label: 'job_AreBathroomsSufficient',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     toiletsBathroomsIssuesRepairs: {
  //       label: 'job_ToiletBathroomIssues',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     toiletsPhoto1: {
  //       label: 'job_ToiletPhoto1',
  //       inputType: 'formUpload',
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       uploadSingle: true,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     toiletsPhoto2: {
  //       label: 'job_ToiletPhoto2',
  //       inputType: 'formUpload',
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       uploadSingle: true,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     bathroomsPhoto1: {
  //       label: 'job_BathroomPhoto1',
  //       inputType: 'formUpload',
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       uploadSingle: true,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     bathroomsPhoto2: {
  //       label: 'job_BathroomPhoto2',
  //       inputType: 'formUpload',
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       uploadSingle: true,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     drinkingWater: {
  //       title: 'job_DrinkingWater',
  //     },
  //     sourceOfDrinkingWater: {
  //       label: 'job_SourceOfDrinkingWater',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: values(drinkingWaterKeys),
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     sourceOfHotWaterForBathing: {
  //       label: 'job_SourceHotWaterForBathing',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: values(hotBathingWaterKeys),
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     drinkingWaterIssuesRepairs: {
  //       label: 'job_DrinkingWaterIssues',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isBoreRequiredForDrinkingWater: {
  //       label: 'job_IsBoreRequiredForDrinkingWater',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     feedbackOnDrinkingWater: {
  //       label: 'job_FeedbackOnDrinkingWater',
  //       inputType: 'input',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const medicalCareAttrFn = useCallback(
  //   () => ({
  //     sickBoardersDetailsEnteredRecords: {
  //       label: 'job_SickBoarderRecordsStatus',
  //       inputType: 'select',
  //       options: [
  //         {
  //           label: 'job_SickBoarderRecordsStatus_Yes',
  //           value: 'YES_RECORDS_ENTERED_CORRECTLY',
  //         },
  //         {
  //           label: 'job_YesRecordsNotEnteredCorrectly',
  //           value: 'YES_RECORDS_NOT_ENTERED_CORRECTLY',
  //         },
  //         {
  //           label: 'job_SickBoarderRecordsStatus_None',
  //           value: 'NO_SICK_BOARDER',
  //         },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     staffNurseAvailableInHostel: {
  //       label: 'job_StaffNurseAvailability',
  //       inputType: 'select',
  //       options: values(availableNursingStaffKeys),
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     medicalOfficerRegularVisits: {
  //       label: 'job_MedicalOfficerVisits',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     firstAidKitAvailableInHostel: {
  //       label: 'job_FirstAidKitAvailability',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereDedicatedSickroom: {
  //       label: 'job_IsThereDedicatedSickroom',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     areSanitaryPadsBeingGiven: {
  //       label: 'job_AreSanitaryPadsBeingGiven',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: [
  //         ...booleanOptions,
  //         { label: 'job_NotApplicable', value: 'NOT_APPLICABLE' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     lastChildHealthMeasurementDate: {
  //       label: 'job_WhenLastChildHealthMeasurementsTaken',
  //       inputType: 'dateTimePicker',
  //       className: 'w-100',
  //       format: DISPLAY_DATE_FORMAT,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     distanceToNearestPhcKm: {
  //       label: 'job_DistanceToNearestPHC',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     medicalCareFeedback: {
  //       label: 'job_MedicalFeedback',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const educationFacilitiesAttrFn = useCallback(
  //   () => ({
  //     boardersSuppliedTextbooks: {
  //       label: 'job_TextbooksSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedNotebooks: {
  //       label: 'job_NotebooksSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedUniforms: {
  //       label: 'job_UniformsSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedTrunkBoxes: {
  //       label: 'job_TrunkBoxesSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedPlatesGlasses: {
  //       label: 'job_PlatesGlassesSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedSchoolBags: {
  //       label: 'job_SchoolBagsSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     boardersSuppliedBeddingMaterial: {
  //       label: 'job_BeddingMaterialSupplied',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     areThereBenchesForEveryStudents: {
  //       label: 'job_AreThereBenchesForEveryStudent',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     howManyBenchesRequired: {
  //       label: 'job_HowManyMoreBenchesAreRequired',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     cosmeticChargesLastPaidUptoDate: {
  //       label: 'job_CosmeticChargesLastPaid',
  //       inputType: 'dateTimePicker',
  //       className: 'w-100',
  //       format: DISPLAY_DATE_FORMAT,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     teachingAsPerAnnualLessonPlan: {
  //       label: 'job_TeachingAsPerLessonPlan',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     distanceToSchoolKm: {
  //       label: 'job_DistanceToSchool',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereLibrary: {
  //       label: 'job_IsThereLibrary',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereComputerLab: {
  //       label: 'job_IsThereComputerLab',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfWorkingComputers: {
  //       label: 'job_NumberOfWorkingComputers',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     educationalStatusFeedback: {
  //       label: 'job_EducationalStatusFeedback',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const foodProvisionAttrFn = useCallback(
  //   () => ({
  //     natureOfCookingFuel: {
  //       label: 'job_NatureOfCookingFuel',
  //       inputType: 'select',
  //       options: [
  //         { label: 'LPG', value: 'LPG' },
  //         { label: 'Firewood', value: 'FIREWOOD' },
  //       ],
  //       mode: 'multiple',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     lpgCylindersAvailable: {
  //       label: 'job_LPGCylindersAvailable',
  //       inputType: 'select',
  //       options: [
  //         { label: 'btn_No', value: 'NO' },
  //         { label: 'job_YesSufficient', value: 'YES_SUFFICIENT' },
  //         { label: 'job_YesInSufficient', value: 'YES_INSUFFICIENT' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     menuChartDisplayed: {
  //       label: 'job_MenuChartDisplayed',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     menuImplementedAsPrescribed: {
  //       label: 'job_MenuImplementedAsPrescribed',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     stockRegisterMaintained: {
  //       label: 'job_StockRegisterMaintained',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     vegetablesStoredAboveGround: {
  //       label: 'job_VegetablesStoredAboveGround',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     exhaustFanInKitchen: {
  //       label: 'job_ExhaustFanInKitchen',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     riceStockRegisterKg: {
  //       label: 'job_RiceStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     riceStockGroundBalanceKg: {
  //       label: 'job_RiceStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInRice: {
  //       label: 'job_VariationInRice',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     dalStockRegisterKg: {
  //       label: 'job_DalStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     dalStockGroundBalanceKg: {
  //       label: 'job_DalStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInDal: {
  //       label: 'job_VariationInDal',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     cookingOilStockRegisterKg: {
  //       label: 'job_CookingOilStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     cookingOilStockGroundBalanceKg: {
  //       label: 'job_CookingOilStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInCookingOil: {
  //       label: 'job_VariationInCookingOil',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     sugarStockRegisterKg: {
  //       label: 'job_SugarStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     sugarStockGroundBalanceKg: {
  //       label: 'job_SugarStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInSugar: {
  //       label: 'job_VariationInSugar',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     idliRavaStockRegister: {
  //       label: 'job_IdliRavaStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     idliRavaStockGroundBalance: {
  //       label: 'job_IdliRavaStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInIdliRava: {
  //       label: 'job_VariationInIdliRava',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     ragiMaltStockRegisterKg: {
  //       label: 'job_RagiMaltStockAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     ragiMaltStockGroundBalanceKg: {
  //       label: 'job_RagiMaltStockGroundBalance',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     variationInRagiMalt: {
  //       label: 'job_VariationInRagiMalt',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       disabled: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     ragiMaltConsumptionDailyKg: {
  //       label: 'job_RagiMaltDailyConsumption',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     milkQuantityRegister: {
  //       label: 'job_MilkQuantityAsPerRegister',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     milkQuantityActualStock: {
  //       label: 'job_MilkQuantityActualStock',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     fruitsProvidedAsPerMenu: {
  //       label: 'job_WhetherFruitsAreProvidedAsPerTheMenuChart',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     vegetablesQuality: {
  //       label: 'job_QualityOfVegetables',
  //       inputType: 'select',
  //       options: values(vegetableQualityKeys),
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     brandOfMilkUsed: {
  //       label: 'job_MilkBrand',
  //       inputType: 'select',
  //       options: [
  //         { label: 'Vijaya', value: 'VIJAYA' },
  //         { label: 'dash_Others', value: 'OTHERS' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     milkPurchaseMethod: {
  //       label: 'job_MilkPurchaseMethod',
  //       inputType: 'select',
  //       options: [
  //         { label: 'job_SuppliedByContractor', value: 'CONTRACTOR_SUPPLIED' },
  //         { label: 'job_PurchasedLocally', value: 'PURCHASED_LOCALLY' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereDiningHallForChildren: {
  //       label: 'job_IsThereDiningHallForChildren',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereFunctioningStudentMessCommittee: {
  //       label: 'job_IsThereFunctioningStudentMessCommittee',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereKitchenGarden: {
  //       label: 'job_IsThereKitchenGarden',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     foodProcurementStorageIssues: {
  //       label: 'job_FoodProcurementIssues',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     mealsNutritionalFeedback: {
  //       label: 'job_MealsFeedback',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     foodStorageVegetablesPhoto: {
  //       label: 'job_PhotoOfFoodStorageVegetables',
  //       inputType: 'formUpload',
  //       md: 24,
  //       xs: 24,
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       uploadSingle: true,
  //       required: true,
  //     },
  //     foodStorageDryItemsPhoto: {
  //       label: 'job_PhotoOfFoodStorageDryItems',
  //       inputType: 'formUpload',
  //       md: 24,
  //       xs: 24,
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       required: true,
  //       max: 2,
  //     },
  //   }),
  //   [],
  // )
  // const safetyAndSecurityAttrFn = useCallback(
  //   () => ({
  //     sufficientLightingOpenSpaces: {
  //       label: 'job_OpenSpaceLightingAtNight',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     dangersCausedByAnimals: {
  //       label: 'job_AnimalDangers',
  //       inputType: 'select',
  //       mode: 'multiple',
  //       options: [
  //         { label: 'job_Rats', value: 'RATS' },
  //         { label: 'job_Dogs', value: 'DOGS' },
  //         { label: 'job_Snakes', value: 'SNAKES' },
  //         { label: 'job_Monkeys', value: 'MONKEYS' },
  //         { label: 'txt_None', value: 'NONE' },
  //       ],
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfStaffStayAtNight: {
  //       label: 'job_NightStaffCount',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     howManyCctvRequired: {
  //       label: 'job_HowManyMoreCCTVsAreRequired',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfCctvsAvailable: {
  //       label: 'job_CCTVAvailableCount',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     numberOfCctvsFunctioning: {
  //       label: 'job_CCTVFunctioningCount',
  //       inputType: 'inputNumber',
  //       required: true,
  //       className: 'w-100',
  //       md: 24,
  //       xs: 24,
  //     },
  //     dailyNightPolicePatrollingRequired: {
  //       label: 'job_PolicePatrolRequired',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereCompoundWall: {
  //       label: 'job_IsThereCompoundWall',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereMainGateWithLock: {
  //       label: 'job_IsThereMainGateWithLock',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     safetyIssuesRequirements: {
  //       label: 'job_SafetyIssues',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const conductionMeetingsAttrFn = useCallback(
  //   () => ({
  //     meetingsConvenedRegularly: {
  //       label: 'job_HWOMeetingsRegular',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     lastParentCommitteeMeetingDate: {
  //       label: 'job_LastParentCommitteeMeeting',
  //       inputType: 'dateTimePicker',
  //       required: true,
  //       className: 'w-100',
  //       format: DISPLAY_DATE_FORMAT,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )
  // const feedbackAttrFn = useCallback(
  //   () => ({
  //     feedbackRequestFromStudents: {
  //       label: 'job_StudentFeedback',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     feedbackRequestFromPrincipal: {
  //       label: 'job_OfficerFeedback',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //   }),
  //   [],
  // )

  const findingsAttrFn = useCallback(
    () => ({
      repairsOtherThanMentionedEarlier: {
        label: 'job_RepairsDescription',
        inputType: 'textArea',
        required: true,
        maxLength: 1000,
        md: 24,
        xs: 24,
      },
      findingsOfInspectionOfficer: {
        label: 'job_InspectionFindings',
        inputType: 'textArea',
        required: true,
        maxLength: 2000,
        md: 24,
        xs: 24,
      },
      inspectingOfficerWithStaffPhoto: {
        label: 'job_OfficerStaffPhoto',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        disableGalleryUpload: true,
        uploadSingle: true,
        required: true,
        md: 24,
        xs: 24,
      },
      inspectingOfficerWithChildrenPhoto: {
        label: 'job_OfficerChildrenPhoto',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        disableGalleryUpload: true,
        uploadSingle: true,
        required: true,
        md: 24,
        xs: 24,
      },
      photosOfMainGate: {
        label: 'job_AddPhotoOfMainGate',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        disableGalleryUpload: true,
        required: true,
        uploadSingle: true,
        md: 24,
        xs: 24,
      },
      hostelPhotos: {
        label: 'job_AddPhotoOfHostelFrontWithName',
        inputType: 'formUpload',
        acceptFileTypes: '.png,.jpg,.jpeg',
        disableGalleryUpload: true,
        required: true,
        uploadSingle: true,
        md: 24,
        xs: 24,
      },
    }),
    [],
  )

  const studentFeedbackAttrFn = useCallback(
    () => ({
      studentTopThreeConcerns: {
        label: 'job_StudentTopThreeConcerns',
        inputType: 'textArea',
        required: true,
        rows: 2,
        maxLength: 2000,
        md: 24,
        xs: 24,
      },
    }),
    [],
  )

  const overallAssessmentAttrFn = useCallback(
    () => ({
      overallHostelCondition: {
        label: 'job_OverallHostelCondition',
        inputType: 'select',
        required: true,
        options: [
          { label: 'job_Excellent', value: 'EXCELLENT' },
          { label: 'job_Good', value: 'GOOD' },
          { label: 'rpt_Average', value: 'AVERAGE' },
          { label: 'job_Poor', value: 'POOR' },
          { label: 'job_Critical', value: 'CRITICAL' },
        ],
        md: 24,
        xs: 24,
      },
    }),
    [],
  )

  const inspectingOfficerFeedbackAttrFn = useCallback(
    () => ({
      inspectingOfficerFeedback: {
        label: 'job_InspectingOfficerFeedback',
        inputType: 'textArea',
        required: true,
        rows: 2,
        maxLength: 2000,
        md: 24,
        xs: 24,
      },
    }),
    [],
  )

  // const curricularActivitiesAttrFn = useCallback(
  //   () => ({
  //     sports: {
  //       title: 'job_Sports',
  //     },
  //     isTherePlayground: {
  //       label: 'job_IsTherePlayground',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     approxPlayAreaInSqMeters: {
  //       label: 'job_ApproximatePlayAreasSquareFeet',
  //       inputType: 'inputNumber',
  //       className: 'w-100',
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     isThereSufficientSportsEquipment: {
  //       label: 'job_IsThereSufficientSportsEquipment',
  //       inputType: 'select',
  //       responsiveInputType: 'RADIO_BUTTON',
  //       options: booleanOptions,
  //       required: true,
  //       md: 24,
  //       xs: 24,
  //     },
  //     otherActivities: {
  //       title: 'job_OtherExtraCurricularActivities',
  //     },
  //     anyOtherExtraCurricularActivities: {
  //       label: 'job_AnyOtherExtraCurricularActivities',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     anyRequestForExtraCurricularActivities: {
  //       label: 'job_AnyRequestForExtraCurricularActivitiesFromChildren',
  //       inputType: 'textArea',
  //       required: true,
  //       maxLength: 1000,
  //       md: 24,
  //       xs: 24,
  //     },
  //     photosOfExtraCurricularActivities: {
  //       label: 'job_PhotosExtraCurricularActivitiesUniqueAspectsDoneChildren',
  //       inputType: 'formUpload',
  //       acceptFileTypes: '.png,.jpg,.jpeg',
  //       required: true,
  //       galleryUpload: true,
  //       md: 24,
  //       xs: 24,
  //       max: 2,
  //     },
  //   }),
  //   [],
  // )

  const administrationAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'studentAttendanceHostelOccupancyRecordsUpdated',
        photoField: 'studentAttendanceHostelOccupancyRecordsUpdatedDmsIds',
        remarkField: 'studentAttendanceHostelOccupancyRecordsUpdatedRemarks',
        label: 'job_StudentAttendanceHostelOccupancyRecordsUpdated',
      }),
      ...inspectionReportFields({
        fieldName: 'physicalStudentCountsMatchAttendanceRecords',
        photoField: 'physicalStudentCountsMatchAttendanceRecordsDmsIds',
        remarkField: 'physicalStudentCountsMatchAttendanceRecordsRemarks',
        label: 'job_PhysicalStudentCountsMatchAttendanceRecords',
      }),
      ...inspectionReportFields({
        fieldName: 'mandatoryRegistersRecordsAvailableUpdated',
        photoField: 'mandatoryRegistersRecordsAvailableUpdatedDmsIds',
        remarkField: 'mandatoryRegistersRecordsAvailableUpdatedRemarks',
        label: 'job_MandatoryRegistersRecordsAvailableUpdated',
      }),
    }),
    [],
  )

  const foodNutritionAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'approvedWeeklyMenuDisplayedFollowed',
        photoField: 'approvedWeeklyMenuDisplayedFollowedDmsIds',
        remarkField: 'approvedWeeklyMenuDisplayedFollowedRemarks',
        label: 'job_ApprovedWeeklyMenuDisplayedFollowed',
      }),
      ...inspectionReportFields({
        fieldName: 'mealsServedAdequateQuantity',
        photoField: 'mealsServedAdequateQuantityDmsIds',
        remarkField: 'mealsServedAdequateQuantityRemarks',
        label: 'job_MealsServedAdequateQuantity',
      }),
      ...inspectionReportFields({
        fieldName: 'foodQualitySatisfactory',
        photoField: 'foodQualitySatisfactoryDmsIds',
        remarkField: 'foodQualitySatisfactoryRemarks',
        label: 'job_FoodQualitySatisfactory',
      }),
      ...inspectionReportFields({
        fieldName: 'nutritionSupplementsSuppliedAsPerNorms',
        photoField: 'nutritionSupplementsSuppliedAsPerNormsDmsIds',
        remarkField: 'nutritionSupplementsSuppliedAsPerNormsRemarks',
        label: 'job_NutritionSupplementsSuppliedAsPerNorms',
      }),
      ...inspectionReportFields({
        fieldName: 'kitchenCleanHygienic',
        photoField: 'kitchenCleanHygienicDmsIds',
        remarkField: 'kitchenCleanHygienicRemarks',
        label: 'job_KitchenCleanHygienic',
      }),
      ...inspectionReportFields({
        fieldName: 'groceriesStoredSafelyHygienically',
        photoField: 'groceriesStoredSafelyHygienicallyDmsIds',
        remarkField: 'groceriesStoredSafelyHygienicallyRemarks',
        label: 'job_GroceriesStoredSafelyHygienically',
      }),
      ...inspectionReportFields({
        fieldName: 'physicalStocksMatchStockRegisters',
        photoField: 'physicalStocksMatchStockRegistersDmsIds',
        remarkField: 'physicalStocksMatchStockRegistersRemarks',
        label: 'job_PhysicalStocksMatchStockRegisters',
      }),
      ...inspectionReportFields({
        fieldName: 'safeDrinkingWaterSufficient',
        photoField: 'safeDrinkingWaterSufficientDmsIds',
        remarkField: 'safeDrinkingWaterSufficientRemarks',
        label: 'job_SafeDrinkingWaterSufficient',
      }),
    }),
    [],
  )

  const accommodationAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'sufficientBedsAvailable',
        photoField: 'sufficientBedsAvailableDmsIds',
        remarkField: 'sufficientBedsAvailableRemarks',
        label: 'job_SufficientBedsAvailable',
      }),
      ...inspectionReportFields({
        fieldName: 'beddingAvailableUsable',
        photoField: 'beddingAvailableUsableDmsIds',
        remarkField: 'beddingAvailableUsableRemarks',
        label: 'job_BeddingAvailableUsable',
      }),
      ...inspectionReportFields({
        fieldName: 'hostelRoomsOvercrowded',
        photoField: 'hostelRoomsOvercrowdedDmsIds',
        remarkField: 'hostelRoomsOvercrowdedRemarks',
        label: 'job_HostelRoomsOvercrowded',
      }),
      ...inspectionReportFields({
        fieldName: 'hostelRoomsCleanVentilatedHabitable',
        photoField: 'hostelRoomsCleanVentilatedHabitableDmsIds',
        remarkField: 'hostelRoomsCleanVentilatedHabitableRemarks',
        label: 'job_HostelRoomsCleanVentilatedHabitable',
      }),
      ...inspectionReportFields({
        fieldName: 'hostelBuildingRepairsRequired',
        photoField: 'hostelBuildingRepairsRequiredDmsIds',
        remarkField: 'hostelBuildingRepairsRequiredRemarks',
        label: 'job_HostelBuildingRepairsRequired',
      }),
    }),
    [],
  )

  const sanitationDrainageAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'premisesCleanFreeFromGarbage',
        photoField: 'premisesCleanFreeFromGarbageDmsIds',
        remarkField: 'premisesCleanFreeFromGarbageRemarks',
        label: 'job_PremisesCleanFreeFromGarbage',
      }),
      ...inspectionReportFields({
        fieldName: 'sufficientToiletsAvailable',
        photoField: 'sufficientToiletsAvailableDmsIds',
        remarkField: 'sufficientToiletsAvailableRemarks',
        label: 'job_SufficientToiletsAvailable',
      }),
      ...inspectionReportFields({
        fieldName: 'toiletsFunctionalHygienic',
        photoField: 'toiletsFunctionalHygienicDmsIds',
        remarkField: 'toiletsFunctionalHygienicRemarks',
        label: 'job_ToiletsFunctionalHygienic',
      }),
      ...inspectionReportFields({
        fieldName: 'bathroomsFunctionalHygienic',
        photoField: 'bathroomsFunctionalHygienicDmsIds',
        remarkField: 'bathroomsFunctionalHygienicRemarks',
        label: 'job_BathroomsFunctionalHygienic',
      }),
      ...inspectionReportFields({
        fieldName: 'solidWasteDisposedProperly',
        photoField: 'solidWasteDisposedProperlyDmsIds',
        remarkField: 'solidWasteDisposedProperlyRemarks',
        label: 'job_SolidWasteDisposedProperly',
      }),
      ...inspectionReportFields({
        fieldName: 'drainageFunctioningNoStagnation',
        photoField: 'drainageFunctioningNoStagnationDmsIds',
        remarkField: 'drainageFunctioningNoStagnationRemarks',
        label: 'job_DrainageFunctioningNoStagnation',
      }),
      ...inspectionReportFields({
        fieldName: 'sanitationImmediateHealthRisk',
        photoField: 'sanitationImmediateHealthRiskDmsIds',
        remarkField: 'sanitationImmediateHealthRiskRemarks',
        label: 'job_SanitationImmediateHealthRisk',
      }),
    }),
    [],
  )

  const electricityLightingAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'electricityAvailableReliable',
        photoField: 'electricityAvailableReliableDmsIds',
        remarkField: 'electricityAvailableReliableRemarks',
        label: 'job_ElectricityAvailableReliable',
      }),
      ...inspectionReportFields({
        fieldName: 'lightingAdequate',
        photoField: 'lightingAdequateDmsIds',
        remarkField: 'lightingAdequateRemarks',
        label: 'job_LightingAdequate',
      }),
      ...inspectionReportFields({
        fieldName: 'electricalFittingsSafe',
        photoField: 'electricalFittingsSafeDmsIds',
        remarkField: 'electricalFittingsSafeRemarks',
        label: 'job_ElectricalFittingsSafe',
      }),
      ...inspectionReportFields({
        fieldName: 'outdoorNightLightingAdequate',
        photoField: 'outdoorNightLightingAdequateDmsIds',
        remarkField: 'outdoorNightLightingAdequateRemarks',
        label: 'job_OutdoorNightLightingAdequate',
      }),
    }),
    [],
  )

  const healthMedicalCareAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'firstAidAvailableServiceable',
        photoField: 'firstAidAvailableServiceableDmsIds',
        remarkField: 'firstAidAvailableServiceableRemarks',
        label: 'job_FirstAidAvailableServiceable',
      }),
      ...inspectionReportFields({
        fieldName: 'sickStudentsRecordedMonitored',
        photoField: 'sickStudentsRecordedMonitoredDmsIds',
        remarkField: 'sickStudentsRecordedMonitoredRemarks',
        label: 'job_SickStudentsRecordedMonitored',
      }),
      ...inspectionReportFields({
        fieldName: 'healthCheckupsConductedScheduled',
        photoField: 'healthCheckupsConductedScheduledDmsIds',
        remarkField: 'healthCheckupsConductedScheduledRemarks',
        label: 'job_HealthCheckupsConductedScheduled',
      }),
      ...inspectionReportFields({
        fieldName: 'communicableDiseasesObserved',
        photoField: 'communicableDiseasesObservedDmsIds',
        remarkField: 'communicableDiseasesObservedRemarks',
        label: 'job_CommunicableDiseasesObserved',
      }),
      ...inspectionReportFields({
        fieldName: 'hygieneMaterialsAvailable',
        photoField: 'hygieneMaterialsAvailableDmsIds',
        remarkField: 'hygieneMaterialsAvailableRemarks',
        label: 'job_HygieneMaterialsAvailable',
      }),
    }),
    [],
  )

  const educationAcademicEnvironmentAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'learningMaterialsAvailable',
        photoField: 'learningMaterialsAvailableDmsIds',
        remarkField: 'learningMaterialsAvailableRemarks',
        label: 'job_LearningMaterialsAvailable',
      }),
      ...inspectionReportFields({
        fieldName: 'schoolAttendanceSatisfactory',
        photoField: 'schoolAttendanceSatisfactoryDmsIds',
        remarkField: 'schoolAttendanceSatisfactoryRemarks',
        label: 'job_SchoolAttendanceSatisfactory',
      }),
      ...inspectionReportFields({
        fieldName: 'studyHoursAcademicSupportFunctioning',
        photoField: 'studyHoursAcademicSupportFunctioningDmsIds',
        remarkField: 'studyHoursAcademicSupportFunctioningRemarks',
        label: 'job_StudyHoursAcademicSupportFunctioning',
      }),
    }),
    [],
  )

  const safetySecurityAttrFn = useCallback(
    () => ({
      ...inspectionReportFields({
        fieldName: 'boundaryProtectionAdequate',
        photoField: 'boundaryProtectionAdequateDmsIds',
        remarkField: 'boundaryProtectionAdequateRemarks',
        label: 'job_BoundaryProtectionAdequate',
      }),
      ...inspectionReportFields({
        fieldName: 'securityArrangementsAdequate',
        photoField: 'securityArrangementsAdequateDmsIds',
        remarkField: 'securityArrangementsAdequateRemarks',
        label: 'job_SecurityArrangementsAdequate',
      }),
      ...inspectionReportFields({
        fieldName: 'safetyHazardsImmediateAttention',
        photoField: 'safetyHazardsImmediateAttentionDmsIds',
        remarkField: 'safetyHazardsImmediateAttentionRemarks',
        label: 'job_SafetyHazardsImmediateAttention',
      }),
    }),
    [],
  )

  return {
    // hostelAdministrationAttrFn,
    // hostelInfraRoomsAttrFn,
    // hostelInfraSanitationAttrFn,
    // medicalCareAttrFn,
    // educationFacilitiesAttrFn,
    // foodProvisionAttrFn,
    // safetyAndSecurityAttrFn,
    // conductionMeetingsAttrFn,
    // feedbackAttrFn,
    findingsAttrFn,
    studentFeedbackAttrFn,
    overallAssessmentAttrFn,
    inspectingOfficerFeedbackAttrFn,
    // curricularActivitiesAttrFn,
    administrationAttrFn,
    foodNutritionAttrFn,
    accommodationAttrFn,
    sanitationDrainageAttrFn,
    electricityLightingAttrFn,
    healthMedicalCareAttrFn,
    educationAcademicEnvironmentAttrFn,
    safetySecurityAttrFn,
  }
}

export default inspectionFieldAttr

